// extracted by mini-css-extract-plugin
module.exports = {"lens":"Scanning_lens__1AfvB","scanner":"Scanning_scanner__1X4in","button":"Scanning_button__KZoPH"};